export default __webpack_public_path__ + "static/media/1131.6f97e526.png";